import { Alert, Autocomplete, Box, Button, Card, CardActions, CardContent, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Paper, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import LogService from "../../services/LogService";
import ILog from "../../types/Log";
import { useEffect, useRef, useState } from "react";
import ConfigUtils from "../../utils/Config";
import IBono from "../../types/Bono";
import IAlert from "../../types/Alert";
import AddIcon from '@mui/icons-material/Add';
import * as constantes from "../../common/Constantes";
import { CONFIGTYPES } from "../../types/Config";
import { IBonoPaciente, IBonoPacientePayload } from "../../types/BonoPaciente";
import IPaciente from "../../types/Paciente";
import { useNavigate } from "react-router-dom";
import PacienteService from "../../services/PacienteService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from '@mui/icons-material/Clear';
import BonoService from "../../services/BonoService";
import Utilities from "../../common/Utilities";
import { calcularCaducidadBono, formatCurrency, getCurrencySymbol } from "../../utils/Factura";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import TablePagination from "../utilities/TablePagination";
import moment from "moment";
import DetalleBonoPaciente from "./facturarBono/DetalleBonoPaciente";
import { IFacturaCompleta } from "./facturarCita/DetalleFacturaComplementaria";
import { EstadoFacturacion, getEstadoFacturacion } from "./common/EstadoFacturacionIcon";
import SelectorEntidadFacturacion, { esFacturacionMultiEntidad } from "./common/SelectorEntidadFacturacion";
import SelectorEntidadConsulta from "./common/SelectorEntidadConsulta";

interface IBonoErrors {
    nombre?: string;
    concepto?: string;
    precio?: string;
    cantidad?: string;
    servicios?: string;
};

const initialBono: IBono = {
  nombre: "",
  concepto: "",
  precio: 0,
  impuesto: 0,
  cantidad: 0,
  compartible: false,
  duracion: "1 año",
  servicios: [],
  activo: true,
  userId: ""
};

interface IBonoPacienteErrors {
  tipoBono?: string;
  pacienteId?: string;
  nombre?: string;
  concepto?: string;
  precio?: string;
  cantidad?: string;
  caducidad?: string;
  servicios?: string;
  entidad?: string;
}

const initialBonoPaciente: IBonoPacientePayload = {
  pacienteId: "",
  nombre: "",
  concepto: "",
  precio: 0,
  impuesto: 0,
  cantidad: 0,
  usado: 0,
  compartible: false,
  caducidad: moment(),
  servicios: [],
  activo: true,
  userId: "",
  compartidoIds: []
}

const Bonos = () => {
    const simboloMoneda = getCurrencySymbol(ConfigUtils.getUserCurrency());
    const history = useNavigate();
    const theme = useTheme();
    const [alert, setAlert] = useState<IAlert>({ open: false, severity: 'info', msg: '' });
    const [loading, setLoading] = useState(true);

    const [bonos, setBonos] = useState<IBono[]>(ConfigUtils.getBonos());
    const [modalBono, setModalBono] = useState<boolean>(false);
    const [isEditBono, setIsEditBono] = useState<boolean>(false);
    const [selectedBono, setSelectedBono] = useState<IBono | null>(null);
    const [loadingBono, setLoadingBono] = useState<boolean>(false);
    const [modalDeleteBono, setModalDeleteBono] = useState<boolean>(false);
    const [errorsBono, setErrorsBono] = useState<IBonoErrors>({});
    const [precioTotal, setPrecioTotal] = useState(0);
    const [inputPrecioBase, setInputPrecioBase] = useState(selectedBono?.precio ? selectedBono.precio.toString().replace(".", ",") : "0,00");

    const [bonosPaciente, setBonosPaciente] = useState<IBonoPaciente[]>([]);
    const [pacientes, setPacientes] = useState<IPaciente[]>([]);

    const [modalBonoPaciente, setModalBonoPaciente] = useState<boolean>(false);
    const [isEditBonoPaciente, setIsEditBonoPaciente] = useState<boolean>(false);
    const [selectedTipoBono, setSelectedTipoBono] = useState<IBono | null>(null);
    const [selectedBonoPaciente, setSelectedBonoPaciente] = useState<IBonoPacientePayload | null>(null);
    const [loadingBonoPaciente, setLoadingBonoPaciente] = useState<boolean>(false);
    const [errorsBonoPaciente, setErrorsBonoPacientes] = useState<IBonoPacienteErrors>({});
    const [precioTotalBonoPaciente, setPrecioTotalBonoPaciente] = useState(0);
    const [inputPrecioBaseBonoPaciente, setInputPrecioBaseBonoPaciente] = useState(selectedBonoPaciente?.precio ? selectedBonoPaciente.precio.toString().replace(".", ",") : "0,00");

    const [page, setPage] = useState(0);

    const [modalDetalleBonoPaciente, setModalDetalleBonoPaciente] = useState(false);
    const [detalleBonoPaciente, setDetalleBonoPaciente] = useState<IBonoPaciente | null>(null);
    const [permisos, setPermisos] = useState<{ [key: string]: boolean }>({});

    const [searchString, setSearchString] = useState('');
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [filterEntidad, setFilterEntidad] = useState<string | null>(null); // null = principal, por defecto

    const servicios = ConfigUtils.getServicios().filter(s => !s.recurrente && s.activo);
    const userId = ConfigUtils.getUserId();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    const handleCloseAlert = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlert({ open: false, severity: 'info', msg: '' });
    };

    const ordenarBonosPaciente = (bonos: IBonoPaciente[]) => {
      const ahora = moment();

      return [...bonos].sort((a, b) => {
        const restantesA = a.cantidad - a.usado;
        const restantesB = b.cantidad - b.usado;
      
        const cadA = moment(a.caducidad);
        const cadB = moment(b.caducidad);
      
        const caducadoA = cadA.isBefore(ahora, "day");
        const caducadoB = cadB.isBefore(ahora, "day");
      
        const agotadoA = restantesA <= 0;
        const agotadoB = restantesB <= 0;
      
        const usableA = !caducadoA && !agotadoA;
        const usableB = !caducadoB && !agotadoB;
      
        // 1️⃣ activos primero
        if (usableA !== usableB) return usableA ? -1 : 1;
      
        // 2️⃣ dentro de activos
        if (usableA && usableB) {
          const cadDiff = cadA.diff(cadB);
          if (cadDiff !== 0) return cadDiff;
        
          // menos sesiones restantes primero
          return restantesA - restantesB;
        }
      
        // 3️⃣ agotados antes que caducados
        if (agotadoA !== agotadoB) return agotadoA ? -1 : 1;
      
        // 4️⃣ ordenar por caducidad dentro del grupo
        return cadA.diff(cadB);
      });
    };

    useEffect(() => {
      if (!userId) return;
      load();
    }, [userId]);

    const load = async () => {
      try {
        const [pacientesResp, bonosPacienteResp] = await Promise.all([
          PacienteService.getAll(),
          BonoService.getBonosPacientes(userId),
        ]);
        setPacientes(pacientesResp.data || []);
        const bonosOrdenados = ordenarBonosPaciente(bonosPacienteResp.data || []);
        setBonosPaciente(bonosOrdenados);
      }  catch (e: any) {
        if (e.response?.status === 401) {
          localStorage.clear();
          history(constantes.R_HOME);
        } else {
          const error: ILog = {
            method: "Bonos.Component.load",
            level: "error",
            message: e.message,
            meta: e.response,
          };
          LogService.logError(error);
          setAlert({ open: true, severity: "error", msg: e.response?.data?.message || e.message });
        }
      } finally {
        setLoading(false);
      }
    };

    const setIsUpdateBono = (bono: IBono) => {
        setIsEditBono(true);
        setSelectedBono(bono);
        const precioTotal = bono.precio + (bono.precio * bono.impuesto) / 100;
        setInputPrecioBase(bono.precio.toFixed(2).replace(".", ","));
        setPrecioTotal(precioTotal);
        setModalBono(true);
    };

    const closeModalBono = () => {
        setIsEditBono(false);
        setSelectedBono(initialBono);
        setErrorsBono({});
        setPrecioTotal(0);
        setInputPrecioBase("");
        setModalBono(false);
    };

    const validateBono = () => {
        const e: IBonoErrors = {};

        if (!selectedBono?.nombre?.trim()) e.nombre = "El nombre es obligatorio";

        const existeNombre = bonos.some(s =>
            s.nombre.trim().toLowerCase() === selectedBono?.nombre?.toLowerCase() &&
            s.activo === selectedBono?.activo &&
            s._id !== selectedBono?._id
        );

        if (existeNombre) {
            e.nombre = "Ya existe un bono con este nombre";
        }

        if (!selectedBono?.concepto?.trim()) e.concepto = "El concepto es obligatorio";
        if ((!selectedBono?.precio || selectedBono.precio <= 0)) e.precio = "El precio debe ser mayor que 0";
        if ((!selectedBono?.cantidad || selectedBono.cantidad <= 0)) e.cantidad = "El nº de sesiones debe ser mayor que 0";
        if (selectedBono?.servicios.length == 0) e.servicios = "Debes seleccionar al menos un servicio";

        setErrorsBono(e);

        return Object.keys(e).length === 0;
    };

    const saveBono = async () => {
        if (!selectedBono) return;
        setLoadingBono(true);
        selectedBono.userId = ConfigUtils.getUserId();

        try {
          const response: any = await BonoService.createBono(selectedBono);
          ConfigUtils.addConfig(CONFIGTYPES.bonos.toString(), response.data);
          const newBonos: IBono[] = [response.data, ...bonos];
          setBonos(newBonos);
          setAlert({ open: true, severity: 'success', msg: 'Bono creado correctamente' });
          closeModalBono();
        } catch (e: any) {
            if (e.response.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Bonos.Component.saveBono', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al crear bono' });
            }
        } finally {
          setLoadingBono(false);
        }
    };

    const updateBono = async () => {
        if (!selectedBono) return;
        setLoadingBono(true);
        try {
            const response = await BonoService.updateBono(selectedBono._id!, selectedBono);
            const newBonos: IBono[] = bonos.map((s) => s._id === response.data._id ? response.data : s);
            setBonos(newBonos);
            ConfigUtils.editConfig(CONFIGTYPES.bonos.toString(), response.data);
            setAlert({ open: true, severity: 'success', msg: 'Bono actualizado correctamente' });
        } catch (e: any) {
            if (e.response.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Bonos.Component.updateBono', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al actualizar bono' });
            }
        } finally {
          closeModalBono();
          setLoadingBono(false);
        }
    };

    const toggleBonoActivo = async () => {
        if (!selectedBono) return;
        setLoadingBono(true);

        try {
            const payload = {
                activo: !selectedBono.activo,
                userId: ConfigUtils.getUserId()
            };
            const response = await BonoService.updateBonoActivo(selectedBono._id!, payload);
            const newBonos: IBono[] = [...bonos.map(s => s._id === response.data._id ? response.data : s)];
            setBonos(newBonos);
            ConfigUtils.editConfig(CONFIGTYPES.bonos.toString(), response.data);
            setAlert({ open: true, severity: 'success', msg: `Bono ${response.data.activo ? 'activado' : 'desactivado'} correctamente` });
        } catch (e: any) {
            if (e.response.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Bonos.Component.toggleBonoActivo', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al actualizar estado del bono' });
            }
        } finally {
          setModalDeleteBono(false);
          setSelectedBono(null);
          setLoadingBono(false);
        }
    };

    const setIsUpdateBonoPaciente = (bonoPaciente: IBonoPaciente, facturaBono: IFacturaCompleta) => {
        setIsEditBonoPaciente(true);
        const bonoPacienteToEdit: IBonoPacientePayload = {
          _id: bonoPaciente._id,
          pacienteId: bonoPaciente.pacienteId,
          nombre: bonoPaciente.nombre,
          concepto: facturaBono.conceptos[0].nombre,
          precio: facturaBono.importeTotal,
          impuesto: facturaBono.impuestos[0].cuota,
          cantidad: bonoPaciente.cantidad,
          usado: bonoPaciente.usado,
          compartible: bonoPaciente.compartible,
          caducidad: moment(bonoPaciente.caducidad),
          servicios: bonoPaciente.servicios,
          activo: bonoPaciente.activo,
          userId: bonoPaciente.userId,
          facturaId: facturaBono._id,
          compartidoIds: bonoPaciente.compartidoIds,
        }
        setSelectedBonoPaciente(bonoPacienteToEdit);
        const selectedTipo = bonos.find(b => b.nombre === bonoPaciente.nombre)!;
        setSelectedTipoBono(selectedTipo);
        const precioTotal = facturaBono.importeTotal;
        setInputPrecioBaseBonoPaciente(facturaBono.importeBase.toFixed(2).replace(".", ","));
        setPrecioTotalBonoPaciente(precioTotal);
        setModalBonoPaciente(true);

        const estadoFacturacion: EstadoFacturacion = getEstadoFacturacion(facturaBono?.estado, facturaBono?.estadoPago);
        const caducado = moment(bonoPaciente.caducidad).isBefore(moment(), "day");
        const tieneUso = bonoPaciente.usado > 0;
        const permisos = camposEditablesPorEstado(estadoFacturacion, caducado, tieneUso);
        setPermisos(permisos);
    };

    const camposEditablesPorEstado = (estadoFacturacion: EstadoFacturacion, caducado: boolean, tieneUso: boolean) => {
      if (caducado) {
        return {
          paciente: false,
          tipoBono: false,
          numeroSesiones: false,
          compartible: false,
          caducidad: true,
          serviciosIncluidos: false,
          precioBase: false,
          impuesto: false,
          nombre: false,
          concepto: false,
        };
      }
      switch (estadoFacturacion) {
        case EstadoFacturacion.PENDIENTE_PAGO:
        case EstadoFacturacion.PAGADA:
          if (tieneUso) {
            return {
              paciente: false,
              tipoBono: false,
              numeroSesiones: false,
              compartible: true,
              caducidad: true,
              serviciosIncluidos: false,
              precioBase: false,
              impuesto: false,
              nombre: false,
              concepto: false,
            };
          }
          return {
            paciente: true,
            tipoBono: true,
            numeroSesiones: true,
            compartible: true,
            caducidad: true,
            serviciosIncluidos: true,
            precioBase: true,
            impuesto: true,
            nombre: true,
            concepto: true,
          };
        case EstadoFacturacion.EMITIDA:
        case EstadoFacturacion.EMITIDA_PENDIENTE_PAGO:
          return {
            paciente: false,
            tipoBono: false,
            numeroSesiones: false,
            compartible: true,
            caducidad: true,
            serviciosIncluidos: !tieneUso,
            precioBase: false,
            impuesto: false,
            nombre: false,
            concepto: false,
          };
        default:
          return {
            paciente: false,
            tipoBono: false,
            numeroSesiones: false,
            compartible: false,
            caducidad: false,
            serviciosIncluidos: false,
            precioBase: false,
            impuesto: false,
            nombre: false,
            concepto: false,
          };
      }
    };

    const closeModalBonoPaciente = () => {
      setIsEditBonoPaciente(false);
      setSelectedBonoPaciente(initialBonoPaciente);
      setErrorsBonoPacientes({});
      setPrecioTotalBonoPaciente(0);
      setInputPrecioBaseBonoPaciente("");
      setSelectedTipoBono(null);
      setModalBonoPaciente(false);
    };

    const validateBonoPaciente = () => {
      const e: IBonoPacienteErrors = {};

      if (!isEditBonoPaciente && esFacturacionMultiEntidad() && selectedBonoPaciente?.entityId === undefined) {
        e.entidad = "Debes seleccionar una entidad de facturación";
      }
      if (!selectedBonoPaciente?.pacienteId) e.pacienteId = "El paciente es obligatorio";
      if (!selectedTipoBono) e.tipoBono = "Debes seleccionar un tipo de bono";
      if (!selectedTipoBono) {
        setErrorsBonoPacientes(e);
        return false;
      }

      if (!selectedBonoPaciente?.nombre?.trim()) e.nombre = "El nombre es obligatorio";
      if (!selectedBonoPaciente?.concepto?.trim()) e.concepto = "El concepto es obligatorio";
      if ((!selectedBonoPaciente?.precio || selectedBonoPaciente.precio <= 0)) e.precio = "El precio debe ser mayor que 0";
      if ((!selectedBonoPaciente?.cantidad || selectedBonoPaciente.cantidad <= 0)) e.cantidad = "El nº de sesiones debe ser mayor que 0";
      if (!selectedBonoPaciente?.caducidad) {
        e.caducidad = "La fecha de caducidad es obligatoria";
      } else if (!selectedBonoPaciente.caducidad.isValid()) {
        e.caducidad = "Debe ser una fecha válida";
      }
      if (selectedBonoPaciente?.servicios.length == 0) e.servicios = "Debes seleccionar al menos un servicio";
      
      setErrorsBonoPacientes(e);
      
      return Object.keys(e).length === 0;
    };

    const saveBonoPaciente = async () => {
      if (!selectedBonoPaciente) return;
        setLoadingBonoPaciente(true);

        try {
          const response = await BonoService.createBonoPaciente(selectedBonoPaciente);
          const newBonosPaciente = ordenarBonosPaciente([
            response.data.bonoPaciente,
            ...bonosPaciente,
          ]);
          setBonosPaciente(newBonosPaciente);

          setAlert({ open: true, severity: 'success', msg: 'Bono de paciente creado correctamente' });
          closeModalBonoPaciente();
          setDetalleBonoPaciente(response.data.bonoPaciente);
          setModalDetalleBonoPaciente(true);
        } catch (e: any) {
          if (e.response.status === 401) {
              localStorage.clear();
              history(constantes.R_HOME);
          } else {
              const error: ILog = { method: 'Bonos.Component.createBonoPaciente', level: 'error', message: e.message, meta: e.response };
              LogService.logError(error);
              setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al crear bono de paciente' });
          }
        } finally {
          setLoadingBonoPaciente(false);
        }
    };

    const updateBonoPaciente = async () => {
      if (!selectedBonoPaciente || !selectedBonoPaciente._id) return;
        setLoadingBonoPaciente(true);

      try {
        const response = await BonoService.updateBonoPaciente(selectedBonoPaciente._id, selectedBonoPaciente);
        const updatedBono = response.data.bonoPaciente;
        const newBonosPaciente = ordenarBonosPaciente(
          bonosPaciente.map(bono =>
            bono._id === updatedBono._id ? updatedBono : bono
          )
        );
        setBonosPaciente(newBonosPaciente);

        setAlert({ open: true, severity: 'success', msg: 'Bono de paciente actualizado correctamente' });
        closeModalBonoPaciente();
        setDetalleBonoPaciente(response.data.bonoPaciente);
        setModalDetalleBonoPaciente(true);
      } catch (e: any) {
        if (e.response.status === 401) {
            localStorage.clear();
            history(constantes.R_HOME);
        } else {
            const error: ILog = { method: 'Bonos.Component.updateBonoPaciente', level: 'error', message: e.message, meta: e.response };
            LogService.logError(error);
            setAlert({ open: true, severity: 'error', msg: e?.response?.data?.message || 'Error al actualizar bono de paciente' });
        }
      } finally {
        setLoadingBonoPaciente(false);
      }
    };

    const openModalDetalle = (bonoPaciente: IBonoPaciente) => {
      setDetalleBonoPaciente(bonoPaciente);
      setModalDetalleBonoPaciente(true);
    };

    const closeModalDetalle = () => {
      setDetalleBonoPaciente(null);
      setModalDetalleBonoPaciente(false);
    };

    const clearFilter = () => {
      setSearchString('');
      setPage(0);
      searchInputRef.current?.focus();
    };

    const search = (e: any) => {
      try {
          const rawValue = e.target.value;
          setSearchString(rawValue);
          setPage(0);
      } catch (e: any) {
          const error: ILog = { method: 'Bonos.Component.search', level: 'error', message: e.message, meta: e.response };
          LogService.logError(error);
      }
    };

    const bonosPacienteFiltrados = ordenarBonosPaciente(
      bonosPaciente.filter((bono) => {
        if ((bono.entityId ?? null) !== filterEntidad) return false;

        if (!searchString.trim()) return true;

        const textoBusqueda = Utilities.normalizeText(searchString);

        const paciente = pacientes.find((p) => p._id === bono.pacienteId);

        const nombrePaciente = Utilities.normalizeText(paciente?.nombre);
        const apellidosPaciente = Utilities.normalizeText(paciente?.apellidos);

        return (
          nombrePaciente.includes(textoBusqueda) ||
          apellidosPaciente.includes(textoBusqueda)
        );
      })
    );

    const bonosPacientePaginados = bonosPacienteFiltrados.slice(
      page * constantes.rowsPerPage,
      page * constantes.rowsPerPage + constantes.rowsPerPage
    );

    if (loading) return <CircularProgress />;

    try {
        return(
         <Paper sx={{ p: 3, borderRadius: 3, boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  letterSpacing: 0.5,
                  flex: 1,
                  minWidth: 0,
                  fontSize: { xs: "1.25rem", sm: "1.75rem" },
                  whiteSpace: { xs: "nowrap", sm: "normal" },
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Bonos
              </Typography>   
          </Box>

          {/* Bonos de pacientes */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '1rem', sm: '1.25rem' },
            }}
          >
            Bonos de pacientes
          </Typography>
          {bonos.length > 0 && <Button variant="contained" color="success" startIcon={<AddIcon />} onClick={() => { setSelectedBonoPaciente(initialBonoPaciente); setModalBonoPaciente(true); }}>
              <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 'bold', color: 'white' }}>Adquirir bono</Typography>
          </Button>}
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <SelectorEntidadConsulta
              value={filterEntidad}
              onChange={value => { setFilterEntidad(value); setPage(0); }}
              sx={{ ml: 2, mt: 1 }}
            />
            <TextField
              placeholder="Buscar por paciente..."
              size="small"
              inputRef={searchInputRef}
              onChange={(e) => search(e)}
              value={searchString}
              InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>), endAdornment: (<InputAdornment position="end"><IconButton onClick={clearFilter}><ClearIcon /></IconButton></InputAdornment>) }}
              sx={{ width: { xs: '100%', sm: '300px' }, ml: 2, mt: 1 }}
            />
            {bonosPacienteFiltrados.length === 0 ? (
                <Typography sx={{ ml: 2, mt: 2 }}>No se han encontrado bonos de pacientes</Typography>
            ) : isMobile ? 
            <Box sx={{ m: 2, mb: 0 }}>
              {bonosPacientePaginados.map((item) => {
                const paciente = pacientes.find((p) => p._id === item.pacienteId);
              
                const serviciosSeleccionados = servicios.filter((s) =>
                  item.servicios.includes(parseInt(s.internalID!))
                );
              
                const restantes = item.cantidad - item.usado;
                const caducado = item.caducidad
                  ? moment(item.caducidad).startOf("day").isBefore(moment().startOf("day"))
                  : false;
              
                const agotado = restantes <= 0;
              
                return (
                  <Paper key={item._id} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
                    
                    {/* PACIENTE */}
                    <Typography variant="body1" fontWeight={500}>
                      {paciente ? `${paciente.nombre} ${paciente.apellidos}` : "-"}
                    </Typography>
                
                    {/* BONO */}
                    <Typography variant="body2" color="text.secondary" mt={0.5}>
                      {item.nombre}
                    </Typography>
                
                    {/* SESIONES + CADUCIDAD */}
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mt={1}
                    >
                      <Typography
                        fontWeight={600}
                        color={
                          agotado
                            ? "error.main"
                            : restantes <= 2
                            ? "warning.main"
                            : "text.primary"
                        }
                      >
                        {restantes}/{item.cantidad} sesiones
                      </Typography>
                      
                      <Typography
                        variant="body2"
                        color={caducado ? "error.main" : "text.secondary"}
                      >
                        {moment(item.caducidad).format("DD/MM/YYYY")}
                      </Typography>
                    </Box>
                      
                    {/* COMPARTIBLE */}
                    <Box mt={1}>
                      {!item.compartible && (
                        <Chip label="Individual" size="small" variant="outlined" />
                      )}
          
                      {item.compartible && item.compartidoIds.length === 0 && (
                        <Chip label="Compartible" size="small" variant="outlined" />
                      )}
          
                      {item.compartible && item.compartidoIds.length > 0 && (
                        <Chip
                          label={`Compartido con ${item.compartidoIds.length}`}
                          size="small"
                          variant="outlined"
                        />
                      )}
                    </Box>
                    
                    {/* SERVICIOS */}
                    <Box mt={1} display="flex" flexWrap="wrap" gap={0.5}>
                      {serviciosSeleccionados.slice(0, 2).map((s) => (
                        <Chip key={s.internalID} label={s.nombre} size="small" />
                      ))}
          
                      {serviciosSeleccionados.length > 2 && (
                        <Chip
                          label={`+${serviciosSeleccionados.length - 2}`}
                          size="small"
                        />
                      )}
                    </Box>
                    
                    {/* ACCIONES */}
                    <Box display="flex" justifyContent="flex-end" mt={1.5}>
                      <IconButton
                        size="small"
                        onClick={() => openModalDetalle(item)}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Paper>
                );
              })}
            </Box> :
            <TableContainer sx={{ m: 2, mb: 0 }}>
              <Table
                size="small"
                sx={{
                  "& .MuiTableCell-root": {
                    py: 0.6,
                  },
                }}
              >
                <TableHead
                  sx={{
                    backgroundColor: "grey.100",
                    "& .MuiTableCell-head": {
                      fontWeight: 600,
                      color: "grey.800",
                      fontSize: "0.85rem",
                      py: 0.75,
                    },
                  }}
                >
                  <TableRow>
                    <TableCell sx={{ width: "20%" }}>Paciente</TableCell>
                    <TableCell sx={{ width: "20%" }}>Bono</TableCell>
                    <TableCell sx={{ width: "8%" }} align="right">Sesiones</TableCell>
                    <TableCell sx={{ width: "12%" }}>Caducidad</TableCell>
                    <TableCell sx={{ width: "12%" }}>Compartible</TableCell>
                    <TableCell sx={{ width: "18%" }}>Servicios</TableCell>
                    <TableCell sx={{ width: 60 }} align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>            

                <TableBody>
                  {bonosPacientePaginados.map((item, index) => {
                    const paciente = pacientes.find(
                      (p) => p._id === item.pacienteId
                    );            

                    const serviciosSeleccionados = servicios.filter((s) =>
                      item.servicios.includes(parseInt(s.internalID!))
                    );            

                    const restantes = item.cantidad - item.usado;
                    const caducado = item.caducidad 
                      ? moment(item.caducidad).startOf("day").isBefore(moment().startOf("day")) 
                      : false;
                    const agotado = restantes <= 0;           

                    return (
                      <TableRow
                        key={item._id}
                        sx={{
                          backgroundColor: index % 2 === 0 ? "white" : "grey.50",
                          "&:hover": {
                            backgroundColor: "grey.100",
                          },
                        }}
                      >
                        <TableCell>{paciente ? `${paciente.nombre} ${paciente.apellidos}` : "-"}</TableCell>            
                        <TableCell>{item.nombre}</TableCell>            

                        {/* Sesiones */}
                        <TableCell align="right">
                          <Tooltip
                            title={`${item.usado} usadas · ${restantes} restantes · ${item.cantidad} totales`}
                          >
                            <Typography
                              fontWeight={600}
                              fontSize="0.9rem"
                              color={
                                agotado
                                  ? "error.main"
                                  : restantes <= 2
                                  ? "warning.main"
                                  : "text.primary"
                              }
                              sx={{ cursor: "default" }}
                            >
                              {restantes}/{item.cantidad}
                            </Typography>
                          </Tooltip>
                        </TableCell>          

                        {/* Caducidad */}
                        <TableCell>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Tooltip title={caducado ? "Bono caducado" : ""}>
                              <Typography
                                fontSize="0.85rem"
                                color={caducado ? "error.main" : "text.primary"}
                              >
                                {moment(item.caducidad).format("DD/MM/YYYY")}
                              </Typography>
                            </Tooltip>
                          </Box>
                        </TableCell>         

                        {/* Compartible */}
                        <TableCell>
                          {!item.compartible && (
                            <Chip
                              label="Individual"
                              size="small"
                              variant="outlined"
                            />
                          )}

                          {item.compartible && item.compartidoIds.length === 0 && (
                            <Chip
                              label="Compartible"
                              size="small"
                              variant="outlined"
                            />
                          )}

                          {item.compartible && item.compartidoIds.length > 0 && (
                            <Tooltip
                              title={item.compartidoIds
                                .map(id => {
                                  const p = pacientes.find(p => p._id === id);
                                  return p ? `${p.nombre} ${p.apellidos}` : "-";
                                })
                                .join(", ")}
                            >
                              <Chip
                                label={`Compartido con ${item.compartidoIds.length}`}
                                size="small"
                                variant="outlined"
                              />
                            </Tooltip>
                          )}
                        </TableCell>

                        {/* Servicios */}
                        <TableCell sx={{ maxWidth: 220 }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                            }}
                          >
                            {serviciosSeleccionados
                              .slice(0, 2)
                              .map((s) => (
                                <Chip
                                  key={s.internalID}
                                  label={s.nombre}
                                  size="small"
                                />
                              ))}           

                            {serviciosSeleccionados.length > 2 && (
                              <Chip
                                label={`+${
                                  serviciosSeleccionados.length - 2
                                }`}
                                size="small"
                              />
                            )}
                          </Box>
                        </TableCell>            

                        <TableCell align="right">
                          <IconButton
                            size="small"
                            onClick={() => openModalDetalle(item)}
                            aria-label="Ver detalle del bono"
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </TableCell>

                      </TableRow>
                    );
                  })}
                </TableBody>            


              </Table>
            </TableContainer>}
          </Grid>

          {/* PAGINACIÓN */}
          <TablePagination
            count={bonosPacienteFiltrados.length}
            page={page}
            rowsPerPage={constantes.rowsPerPage}
            onPageChange={setPage}
          />

          {/* Bonos disponibles */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '1rem', sm: '1.25rem' },
              mt: 2
            }}
          >
            Bonos disponibles
          </Typography>
          <Button variant="contained" color="success" startIcon={<AddIcon />} onClick={() => { setSelectedBono(initialBono); setModalBono(true); }}>
              <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 'bold', color: 'white' }}>Añadir bono</Typography>
          </Button>
          <Grid container spacing={2} sx={{ mt: 1 }}>
              {bonos.length === 0 ? (
                  <Typography sx={{ ml: 2 }}>No se han encontrado bonos</Typography>
              ) : bonos.map(b => (
                  <Grid item xs={12} sm={6} md={4} key={b._id}>
                      <Card variant="outlined" sx={{ backgroundColor: b.activo ? 'white' : '#f0f0f0' }}>
                          <CardContent>
                            {/* NOMBRE */}
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                              {b.nombre}
                            </Typography>                         

                            {/* CONCEPTO */}
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                              {b.concepto}
                            </Typography>                         

                            {/* BLOQUE DE PRECIO */}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 1 }}>
                              <Typography variant="body2">
                                <strong>Precio:</strong> {formatCurrency(b.precio, ConfigUtils.getUserCurrency())}
                              </Typography>
                              <Typography variant="body2">
                                <strong>Impuesto:</strong> {b.impuesto}%
                              </Typography>
                            </Box>                          

                            {/* BLOQUE DE CHIPS */}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                              <Chip
                                label={b.compartible ? "Compartible" : "No compartible"}
                                size="small"
                                color={b.compartible ? "success" : "default"}
                              />
                              <Chip
                                label={`Duración: ${b.duracion}`}
                                size="small"
                                color="primary"
                              />
                              <Chip
                                label={`Sesiones: ${b.cantidad}`}
                                size="small"
                                color="secondary"
                              />
                            </Box>                          

                            {/* SERVICIOS INCLUIDOS */}
                            {b.servicios?.length > 0 && (
                              <Box sx={{ mt: 1 }}>
                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.3 }}>
                                  Servicios incluidos:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  {b.servicios
                                    .map(internalID =>
                                      servicios.find(s => s.internalID?.toString() === internalID.toString())?.nombre || internalID
                                    )
                                    .join(", ")}
                                </Typography>
                              </Box>
                            )}
                          </CardContent>
                          <CardActions>
                              <Button size="small" disabled={!b.activo} onClick={() => setIsUpdateBono(b)}>Editar</Button>
                              <Button size="small" color="error" onClick={() =>  { setSelectedBono(b); setModalDeleteBono(true); }}>{b.activo ? 'Desactivar' : 'Activar'}</Button>
                          </CardActions>
                      </Card>
                  </Grid>
              ))}
          </Grid>

          {/* AÑADIR / EDITAR BONO */}
          <Dialog open={modalBono} maxWidth="md" fullWidth onClose={closeModalBono}>
              <DialogContent>
                  <Typography variant="h5">{isEditBono ? "Editar bono" : "Crear bono"}</Typography>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                      {/* Nombre */}
                      <Grid item xs={12} md={3}>
                          <TextField
                              fullWidth
                              label="Nombre*"
                              value={selectedBono?.nombre || ""}
                              onChange={(e) => setSelectedBono(s => ({ ...s!, nombre: e.target.value }))}
                              error={Boolean(errorsBono?.nombre)}
                              helperText={errorsBono?.nombre}
                          />
                      </Grid> 
                      {/* Concepto */}
                      <Grid item xs={12} md={7}>
                          <TextField
                              fullWidth
                              label="Concepto*"
                              value={selectedBono?.concepto || ""}
                              onChange={(e) =>
                                  setSelectedBono(s => ({ ...s!, concepto: e.target.value }))
                              }
                              error={Boolean(errorsBono?.concepto)}
                              helperText={errorsBono?.concepto}
                          />
                      </Grid>
                      {/* Cantidad */}
                      <Grid item xs={12} md={2}>
                          <TextField
                              fullWidth
                              label="Nº de sesiones*"
                              value={selectedBono?.cantidad || 0}
                              onChange={(e) =>
                                  setSelectedBono(s => ({ ...s!, cantidad: parseInt(e.target.value) || 0 }))
                              }
                              error={Boolean(errorsBono?.cantidad)}
                              helperText={errorsBono?.cantidad}
                          />
                      </Grid>
                       {/* Selección de servicios */}
                      <Grid item md={8} xs={12}>
                          {servicios.length !== 0 && 
                          <FormControl fullWidth error={Boolean(errorsBono?.servicios)}>
                            <InputLabel id="servicios-label">
                              Servicios incluidos*
                            </InputLabel>                           
                            <Select
                              labelId="servicios-label"
                              id="servicios"
                              multiple
                              value={selectedBono?.servicios || []}
                              label="Servicios incluidos*"
                              onChange={(e) => {
                                const values =
                                  typeof e.target.value === "string"
                                    ? e.target.value.split(",").map(Number)
                                    : e.target.value;
                                setSelectedBono(s => ({ ...s!, servicios: values }));
                              }}
                              renderValue={(selected) => (
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                  {selected.map((value) => (
                                    <Chip
                                      key={value}
                                      size="small"
                                      label={servicios.find(s => s.internalID == value.toString())?.nombre}
                                    />
                                  ))}
                                </Box>
                              )}
                            >
                              {servicios
                                .filter(s => s.activo)
                                .map((item) => (
                                  <MenuItem key={item.internalID!} value={item.internalID!}>
                                    {item.nombre}
                                  </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText sx={{ minHeight: 20 }}>
                              {errorsBono?.servicios || " "}
                            </FormHelperText>
                          </FormControl>}
                      </Grid>
                      {/* Duración */}
                      <Grid item xs={12} md={2}>
                        <FormControl fullWidth>
                          <InputLabel id="duracion-label">Duración*</InputLabel>
                          <Select
                            labelId="duracion-label"
                            id="duracion"
                            value={selectedBono?.duracion || "1 año"}
                            label="Duración*"
                            onChange={(e) =>
                              setSelectedBono(s => ({ ...s!, duracion: e.target.value }))
                            }
                          >
                            {["30 días", "6 meses", "1 año"].map((opcion) => (
                              <MenuItem key={opcion} value={opcion}>
                                {opcion}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      {/* Compartible */}
                      <Grid
                        item
                        xs={12}
                        md={2}
                        display="flex"
                        alignItems="flex-start"
                        justifyContent="center"
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 0.5
                          }}
                        >
                          <Switch
                            checked={selectedBono?.compartible || false}
                            onChange={(e) =>
                              setSelectedBono(s => ({ ...s!, compartible: e.target.checked }))
                            }
                          />
                          <Typography variant="caption">
                            Compartible
                          </Typography>
                        </Box>
                      </Grid>
                      {/* Bloque precio e impuesto */}
                      <Grid item xs={12}>
                        <Box sx={{ p: 1, borderRadius: 2 }}>
                          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>Precio e impuestos</Typography>
                          <Grid container spacing={2} alignItems="center">
                            {/* Precio base */}
                            <Grid item xs={12} sm={4}>
                              <TextField
                                fullWidth
                                type="text"
                                label={`Precio base (${simboloMoneda})*`}
                                value={
                                  selectedBono?.precio !== undefined && selectedBono?.precio !== null
                                  ? inputPrecioBase
                                  : "0,00"
                                }
                                onChange={(e) => {
                                  let raw = e.target.value;
                                  setInputPrecioBase(raw);
                                  const normalized = raw.replace(",", ".");
                                  if (/^\d*([.,]\d*)?$/.test(raw)) {
                                    const precio = parseFloat(normalized);
                                    setSelectedBono((s) => {
                                      const impuesto = s?.impuesto ?? 0;
                                      const precioTotalCalc = !isNaN(precio)
                                        ? precio + (precio * impuesto) / 100
                                        : 0;
                                      setPrecioTotal(precioTotalCalc);
                                      return {
                                        ...s!,
                                        precio: !isNaN(precio) ? precio : 0,
                                      };
                                    });
                                  }
                                }}
                                onBlur={() => {
                                  const precio = selectedBono?.precio ?? 0;
                                  const formatted = precio.toFixed(2).replace(".", ",");
                                  setInputPrecioBase(formatted);
                                }}
                                error={Boolean(errorsBono?.precio)}
                                helperText={errorsBono?.precio}
                              />
                            </Grid>
                            {/* Impuesto */}
                            <Grid item xs={12} sm={4}>
                              <TextField
                                fullWidth
                                select
                                label="Impuesto (%)*"
                                value={selectedBono?.impuesto}
                                onChange={(e) => {
                                  setSelectedBono(s => {
                                    const impuesto = Number(e.target.value);
                                    const precio = s!.precio ?? 0;
                                    const precioTotal = precio + (precio * impuesto) / 100;
                                    setPrecioTotal(precioTotal);                             
                                    return {
                                      ...s!,
                                      impuesto
                                    };
                                  })
                                }}
                              >
                                {constantes.IMPUESTOS.map((impuesto) => (
                                  <MenuItem key={impuesto} value={impuesto}>
                                    {impuesto}%
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                            {/* Precio total */}
                            <Grid item xs={12} sm={4}>
                              <TextField
                                fullWidth
                                type="number"
                                label={`Precio total (${simboloMoneda})`}
                                value={precioTotal.toFixed(2)}
                                InputProps={{ readOnly: true, sx: {
                                  backgroundColor: '#f0f0f0',
                                  color: '#555',
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#bdbdbd'
                                  }
                                }}}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                  </Grid>
              </DialogContent>
              {loadingBono ? (
                  <Grid container>
                      <CircularProgress style={{ margin: '20px auto' }} />
                  </Grid>
              ) : (
                  <DialogActions>
                      <Button onClick={() => {
                          if (!validateBono()) return;
                          isEditBono ? updateBono() : saveBono();
                      }}>Guardar</Button>
                      <Button onClick={closeModalBono}>Cancelar</Button>
                  </DialogActions>
              )}
          </Dialog>

          {/* DESACTIVAR BONO */}
          <Dialog open={modalDeleteBono} maxWidth="sm">
              <DialogTitle>{selectedBono?.activo ? 'DESACTIVAR BONO' : 'ACTIVAR BONO'}</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                      {selectedBono
                          ? `¿Está seguro de que desea ${selectedBono.activo ? 'desactivar' : 'activar'} el bono "${selectedBono.nombre}"?`
                          : 'Bono no seleccionado.'}
                  </DialogContentText>
              </DialogContent>
              <DialogActions>
                  <Button onClick={toggleBonoActivo} color="primary">SI</Button>
                  <Button onClick={() => { setModalDeleteBono(false); setSelectedBono(initialBono); }} color="primary" autoFocus>NO</Button>
              </DialogActions>
          </Dialog>

          {/* AÑADIR / EDITAR BONO PACIENTE */}
          <Dialog open={modalBonoPaciente} maxWidth="md" fullWidth onClose={closeModalBonoPaciente}>
            <DialogContent sx={{ minHeight: 460 }}>
              <Typography variant="h5">{isEditBonoPaciente ? "Editar bono de paciente" : "Adquirir nuevo bono de paciente"}</Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                {!isEditBonoPaciente &&
                  <Grid item xs={12}>
                    <SelectorEntidadFacturacion
                      value={selectedBonoPaciente?.entityId}
                      onChange={value => { setSelectedBonoPaciente(s => ({ ...s!, entityId: value })); setErrorsBonoPacientes(prev => ({ ...prev, entidad: undefined })); }}
                      error={!!errorsBonoPaciente.entidad}
                    />
                  </Grid>
                }
                <Grid item md={6} xs={12}>
                  <Autocomplete 
                    disabled={isEditBonoPaciente && !permisos.paciente}
                    disablePortal
                    autoComplete
                    id="paciente"
                    value={pacientes.find(p => p._id === selectedBonoPaciente?.pacienteId) || null}
                    options={pacientes}
                    noOptionsText={'No se han encontrado pacientes'}
                    renderOption={(props, option) => { return (<li {...props} key={option._id}>{`${option.nombre} ${option.apellidos}`}</li>) }}
                    renderInput={(params) => <TextField required {...params} label="Paciente" variant="outlined" margin="dense" fullWidth error={!!errorsBonoPaciente.pacienteId} helperText={errorsBonoPaciente.pacienteId} />}
                    onChange={(_, value) => { setSelectedBonoPaciente(s => ({ ...s!, pacienteId: value?._id! })); setErrorsBonoPacientes((prev) => ({ ...prev, pacienteId: undefined })) }}
                    getOptionLabel={(option) => `${option.nombre} ${option.apellidos}` || ""}
                    filterOptions={(options, params) => Utilities.filterPacientesAutocomplete(options, params.inputValue)}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <FormControl fullWidth sx={{ mt: 1 }} error={!!errorsBonoPaciente.tipoBono}>
                    <InputLabel id="select-bono-label">Tipo de bono*</InputLabel>
                    <Select
                      labelId="select-bono-label"
                      value={selectedTipoBono?.internalID?.toString() ?? ""}
                      label="Tipo de bono*"
                      disabled={isEditBonoPaciente && !permisos.tipoBono}
                      onChange={(e) => {
                        const tipoBono = bonos.find((s) => s.internalID?.toString() === e.target.value);
                        if (tipoBono) {
                          setSelectedTipoBono(tipoBono);
                          const caducidad = moment(calcularCaducidadBono(tipoBono.duracion));
                          const precioTotalCalculado = tipoBono.precio + (tipoBono.precio * tipoBono.impuesto) / 100;
                          setPrecioTotalBonoPaciente(precioTotalCalculado);
                          setInputPrecioBaseBonoPaciente(tipoBono.precio.toFixed(2).replace(".", ","));
                          setSelectedBonoPaciente(s => ({
                            ...s!,
                            nombre: tipoBono.nombre,
                            concepto: tipoBono.concepto,
                            precio: tipoBono.precio,
                            impuesto: tipoBono.impuesto,
                            cantidad: tipoBono.cantidad,
                            usado: 0,
                            compartible: tipoBono.compartible,
                            caducidad,
                            servicios: tipoBono.servicios,
                            userId: tipoBono.userId,
                            compartidoIds: []
                          }))
                          setErrorsBonoPacientes((prev: IBonoPacienteErrors) => ({ 
                            ...prev, 
                            tipoBono: undefined,
                            nombre: undefined,
                            concepto: undefined,
                            cantidad: undefined,
                            caducidad: undefined,
                            servicios: undefined,
                            precio: undefined 
                          }));
                        }
                      }}
                    >
                      {bonos.filter((m) => m.activo).map((m) => (
                        <MenuItem key={m.internalID?.toString()} value={m.internalID?.toString()}>
                          {m.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                    {errorsBonoPaciente.tipoBono && (
                      <Typography sx={{ color: "#d32f2f", fontSize: "0.75rem", mt: 1 }}>{errorsBonoPaciente.tipoBono}</Typography>
                    )}
                  </FormControl>
                </Grid>

                {selectedTipoBono &&  <>
                  <Grid item md={3} xs={12}>
                    {/* Nombre */}
                    <TextField
                      label="Nombre*"
                      fullWidth
                      disabled={isEditBonoPaciente && !permisos.nombre}
                      sx={{ mb: 2 }}
                      value={selectedBonoPaciente?.nombre}
                      onChange={(e) => {
                        setSelectedBonoPaciente(s => ({ ...s!, nombre: e.target.value }));
                        setErrorsBonoPacientes((prev: IBonoPacienteErrors) => ({ ...prev, nombre: undefined }));
                      }}
                      error={!!errorsBonoPaciente.nombre}
                      helperText={errorsBonoPaciente.nombre}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    {/* Concepto */}
                    <TextField
                      label="Concepto*"
                      fullWidth
                      disabled={isEditBonoPaciente && !permisos.concepto}
                      sx={{ mb: 2 }}
                      value={selectedBonoPaciente?.concepto}
                      onChange={(e) => {
                        setSelectedBonoPaciente(s => ({ ...s!, concepto: e.target.value }))
                        setErrorsBonoPacientes((prev: IBonoPacienteErrors) => ({ ...prev, concepto: undefined }));
                      }}
                      error={!!errorsBonoPaciente.concepto}
                      helperText={errorsBonoPaciente.concepto}
                    />  
                  </Grid>
                  <Grid item md={2} xs={12}>
                    {/* Nº de sesiones */}
                    <TextField
                      label="Nº de sesiones*"
                      fullWidth
                      disabled={isEditBonoPaciente && !permisos.numeroSesiones}
                      sx={{ mb: 2 }}
                      value={selectedBonoPaciente?.cantidad || 0}
                      onChange={(e) => {
                        setSelectedBonoPaciente(s => ({ ...s!, cantidad: parseInt(e.target.value) }))
                        setErrorsBonoPacientes((prev: IBonoPacienteErrors) => ({ ...prev, cantidad: undefined }));
                      }}
                      error={!!errorsBonoPaciente.cantidad}
                      helperText={errorsBonoPaciente.cantidad}
                    />  
                  </Grid>                  
                  <Grid
                    item
                    xs={12}
                    md={1}
                    display="flex"
                    alignItems="flex-start"
                    justifyContent="center"
                  >
                    {/* Compartible */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 0.5
                      }}
                    >
                      <Switch
                        checked={selectedBonoPaciente?.compartible || false}
                        disabled={isEditBonoPaciente && !permisos.compartible}
                        onChange={(e) =>
                          setSelectedBonoPaciente(s => ({ ...s!, compartible: e.target.checked }))
                        }
                      />
                      <Typography variant="caption">
                        Compartible
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        label="Fecha de caducidad"
                        value={selectedBonoPaciente?.caducidad}
                        minDate={moment()}
                        disabled={isEditBonoPaciente && !permisos.caducidad}
                        onChange={(date) => {
                          if (date) {
                            setSelectedBonoPaciente(s => ({ ...s!, caducidad: date }))
                            setErrorsBonoPacientes((prev: IBonoPacienteErrors) => ({ ...prev, caducidad: undefined }));
                          }
                        }}
                        renderInput={(params) => <TextField required fullWidth error={!!errorsBonoPaciente.caducidad} helperText={errorsBonoPaciente.caducidad} {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item md={9} xs={12}>
                    {servicios.length !== 0 && 
                    <FormControl fullWidth error={Boolean(errorsBonoPaciente?.servicios)}>
                      <InputLabel id="servicios-label">
                        Servicios incluidos*
                      </InputLabel>                           
                      <Select
                        labelId="servicios-label"
                        id="servicios"
                        multiple
                        value={selectedBonoPaciente?.servicios || []}
                        label="Servicios incluidos*"
                        disabled={isEditBonoPaciente && !permisos.serviciosIncluidos}
                        onChange={(e) => {
                          const values =
                            typeof e.target.value === "string"
                              ? e.target.value.split(",").map(Number)
                              : e.target.value;
                          setSelectedBonoPaciente(s => ({ ...s!, servicios: values }));
                        }}
                        renderValue={(selected) => (
                          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                            {selected.map((value) => (
                              <Chip
                                key={value}
                                size="small"
                                label={servicios.find(s => s.internalID == value.toString())?.nombre}
                              />
                            ))}
                          </Box>
                        )}
                      >
                        {servicios
                          .filter(s => s.activo)
                          .map((item) => (
                            <MenuItem key={item.internalID!} value={item.internalID!}>
                              {item.nombre}
                            </MenuItem>
                          ))}
                      </Select>
                      <FormHelperText>
                        {errorsBonoPaciente?.servicios || " "}
                      </FormHelperText>
                    </FormControl>}
                  </Grid>

                  {/* Bloque precio e impuesto */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>Precio e impuestos</Typography>
                    <Grid container spacing={2} alignItems="center">
                      {/* Precio base */}
                      <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            type="text"
                            label={`Precio base (${simboloMoneda})*`}
                            value={
                              selectedBonoPaciente?.precio !== undefined && selectedBonoPaciente?.precio !== null
                              ? inputPrecioBaseBonoPaciente
                              : "0,00"
                            }
                            disabled={isEditBonoPaciente && !permisos.precioBase}
                            onChange={(e) => {
                              let raw = e.target.value;
                              setInputPrecioBaseBonoPaciente(raw);
                              setErrorsBonoPacientes((prev: IBonoPacienteErrors) => ({ ...prev, precio: undefined }));
                              const normalized = raw.replace(",", ".");
                              if (/^\d*([.,]\d*)?$/.test(raw)) {
                                const precio = parseFloat(normalized);
                                setSelectedBonoPaciente((s) => {
                                  const impuesto = s?.impuesto ?? 0;
                                  const precioTotalCalc = !isNaN(precio)
                                    ? precio + (precio * impuesto) / 100
                                    : 0;
                                  setPrecioTotalBonoPaciente(precioTotalCalc);
                                  return {
                                    ...s!,
                                    precio: !isNaN(precio) ? precio : 0,
                                  };
                                });
                              }
                            }}
                            onBlur={() => {
                              const precio = selectedBonoPaciente?.precio ?? 0;
                              const formatted = precio.toFixed(2).replace(".", ",");
                              setInputPrecioBaseBonoPaciente(formatted);
                            }}
                            error={Boolean(errorsBonoPaciente?.precio)}
                            helperText={errorsBonoPaciente?.precio}
                          />
                      </Grid>
                      {/* Impuesto */}
                      <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            select
                            label="Impuesto (%)*"
                            value={selectedBonoPaciente?.impuesto}
                            disabled={isEditBonoPaciente && !permisos.impuesto}
                            onChange={(e) => {
                              setSelectedBonoPaciente(s => {
                                const impuesto = Number(e.target.value);
                                const precio = s!.precio ?? 0;
                                const precioTotal = precio + (precio * impuesto) / 100;
                                setPrecioTotalBonoPaciente(precioTotal);                             
                                return {
                                  ...s!,
                                  impuesto
                                };
                              })
                            }}
                          >
                            {constantes.IMPUESTOS.map((impuesto) => (
                              <MenuItem key={impuesto} value={impuesto}>
                                {impuesto}%
                              </MenuItem>
                            ))}
                          </TextField>
                      </Grid>
                      {/* Precio total */}
                      <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            type="number"
                            label={`Precio total (${simboloMoneda})`}
                            value={precioTotalBonoPaciente.toFixed(2)}
                            InputProps={{ readOnly: true, sx: {
                              backgroundColor: '#f0f0f0',
                              color: '#555',
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#bdbdbd'
                              }
                            }}}
                          />
                      </Grid>
                    </Grid>
                  </Grid>
                </>}
              </Grid>
            </DialogContent>
            {loadingBonoPaciente ? (
              <Grid container>
                  <CircularProgress style={{ margin: '20px auto' }} />
              </Grid>
            ) : (
              <DialogActions>
                  <Button onClick={() => {
                      if (!validateBonoPaciente()) return;
                      isEditBonoPaciente ? updateBonoPaciente() : saveBonoPaciente();
                  }}>{isEditBonoPaciente ? "Editar" : "Guardar"}</Button>
                  <Button onClick={closeModalBonoPaciente}>Cancelar</Button>
              </DialogActions>
            )}
          </Dialog>

          {/* DETALLE BONO PACIENTE */}
          {modalDetalleBonoPaciente && 
            <DetalleBonoPaciente
              bonoPaciente={detalleBonoPaciente!}
              pacientes={pacientes}
              servicios={servicios}
              open={modalDetalleBonoPaciente}
              onClose={closeModalDetalle}
              onEditar={(bono, factura) => setIsUpdateBonoPaciente(bono, factura)}
              onAnular={(_id) => {
                const nuevosBonos = bonosPaciente.filter(b => b._id !== _id);
                setBonosPaciente(nuevosBonos);
                setAlert({ open: true, severity: "success", msg: "Bono anulado correctamente" });
              }}
              onEntidadCambiada={(bonoAnuladoId, bonoNuevo) => {
                setBonosPaciente(prev => [bonoNuevo, ...prev.filter(b => b._id !== bonoAnuladoId)]);
                setAlert({ open: true, severity: "success", msg: "Entidad de facturación cambiada correctamente" });
              }}
            />
          }

          <Snackbar open={alert.open} autoHideDuration={6000} onClose={handleCloseAlert}>
              <Alert variant="filled" onClose={handleCloseAlert} severity={alert.severity} sx={{ width: '100%' }}>{alert.msg}</Alert>
          </Snackbar>
        </Paper>
    );

    } catch (e: any) {
        const error: ILog = { method: 'Bonos.Component', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return (
            <Alert severity="error">{e.message}</Alert>
        );
    }
  
};

export default Bonos;